module.exports = __webpack_public_path__ + "static/img/add.537d27b1.svg";